import React, { Fragment, useEffect } from "react";
import { useState } from "react";
import { Badge, Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import { Table } from "reactstrap";
import NoData from "../../../common/NoData";
import "./style.css";
import RequestsService from "../../../../services/HRM/RequestsService";
import ReasonModal from "./ReasonModal";
import { toast } from "react-toastify";
import CancellationService from "../../../../services/HRM/CancellationService";
import ExtensionService from "../../../../services/HRM/ExtensionService";

const tabs = ["requests", "extension", "cancellation"];

const Requests = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [selectTab, setSelectTab] = useState(tabs[0]);
	const lang = useSelector((state) => state.auth?.lang);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [reasonModal, setReasonModal] = useState(false);
	const requestsService = new RequestsService();
	const cancellationService = new CancellationService();
	const extensionService = new ExtensionService();

	const changeStatusToggle = (id, status) => {
		let data = {
			status: status,
		};
		let service =
			selectTab === tabs[0]
				? requestsService
				: selectTab === tabs[1]
					? extensionService
					: cancellationService;
		service.changeStatus(id, data).then((res) => {
			if (res?.status === 200) {
				toast.success(Translate[lang].updated_status_successfully);
				setShouldUpdate((prev) => !prev);
			}
		});
	};

	useEffect(() => {
		if (selectTab === tabs[0]) {
			setLoading(true);
			requestsService
				.getList()
				.then((res) => {
					if (res?.status === 200) {
						setData(res?.data?.data);
						setHasData(1);
					} else {
						setHasData(0);
					}
				})
				.catch((err) => {
					setHasData(0);
				})
				.finally(() => setLoading(false));
		}
		if (selectTab !== tabs[0]) {
			let service =
				selectTab === tabs[1] ? extensionService : cancellationService;
			setLoading(true);
			service
				.getList()
				.then((res) => {
					if (res?.status === 200) {
						setData(
							res?.data?.data?.map((item) => {
								return {
									...item?.vacation,
									...item,
								};
							}),
						);
						setHasData(1);
					} else {
						setHasData(0);
					}
				})
				.catch((err) => {
					setHasData(0);
				})
				.finally(() => setLoading(false));
		}
	}, [selectTab, shouldUpdate]);

	return (
		<Fragment>
			<Card className="mb-3 py-3">
				<div className="custom-tabs-div">
					{tabs?.map((tab, index) => {
						return (
							<p
								key={index}
								className={`${tab === selectTab ? "activeP" : ""}`}
								onClick={() => setSelectTab(tab)}>
								{Translate[lang][tab]}
							</p>
						);
					})}
				</div>
			</Card>

			<Card>
				<Card.Body className={`${hasData === 0 ? "text-center" : ""}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									{/* <th className="px-2">
											<strong>I.D</strong>
										</th> */}
									<th className="px-2">
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.company_email}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.department}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.departure_date}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.return_date}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.number_of_days}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.description}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.reason}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.type}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.status}</strong>
									</th>
									<th className="px-2">
										<strong>{Translate[lang]?.actions}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<tr key={index}>
												{/* <td className="text-nowrap">
														<strong>{item?.employee?.id}</strong>
													</td> */}
												<td className="text-nowrap">{`${item?.employee?.name}`}</td>
												<td className="text-nowrap">
													{item?.employee?.companyEmail}
												</td>
												<td className="text-nowrap">
													{item?.employee?.department?.name}
												</td>
												<td className="text-nowrap text-center">
													{item?.departureDay?.split("T")[0]}
												</td>
												<td className="text-nowrap text-center">
													{item?.returnDay?.split("T")[0]}
												</td>
												<td className="text-nowrap">{item?.numberOfDays}</td>
												<td className="text-nowrap">
													{item?.reason?.replaceAll("_", " ")}
												</td>
												<td className="text-nowrap">
													<i
														className="la la-eye"
														onClick={() => setReasonModal(true)}></i>
													{reasonModal && (
														<ReasonModal
															modal={reasonModal}
															setModal={() => setReasonModal(false)}
															reason={item?.description}
														/>
													)}
												</td>
												<td className="text-nowrap">
													{Translate[lang][item?.type?.toLocaleLowerCase()]}
												</td>
												<td className="text-nowrap">
													<Badge
														variant={
															item?.status?.toLocaleLowerCase() === "approved"
																? "success"
																: item?.status?.toLocaleLowerCase() ===
																	  "rejected"
																	? "danger"
																	: "warning"
														}>
														{Translate[lang][item?.status?.toLocaleLowerCase()]}
													</Badge>
												</td>
												<td className="d-flex gap-8">
													{item?.status?.toLocaleLowerCase() === "pending" ? (
														<>
															<Badge
																variant="success"
																className="cursor-pointer"
																onClick={() =>
																	changeStatusToggle(item?.id, "APPROVED")
																}>
																<i className="la la-check"></i>
															</Badge>
															<Badge
																variant="danger"
																className="cursor-pointer"
																onClick={() =>
																	changeStatusToggle(item?.id, "REJECTED")
																}>
																<i className="la la-trash"></i>
															</Badge>
														</>
													) : (
														"-"
													)}
												</td>
											</tr>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
				</Card.Body>
			</Card>
		</Fragment>
	);
};

export default Requests;
